import type { FaireProductEntity } from "../../entity_types/product";

export const p_26vg7umpq7: FaireProductEntity = {
  token: "p_26vg7umpq7",
  type: "product",
  name: "Favorite Brother Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/e2de68a59654c281f9bc204588110e7eddfc499a263c944448313bec9b7b1abc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a54663911bdbfdead14766c3c3f3f10c45edf913bdfb0821db8429bdf58f7cc.jpeg",
    "https://cdn.faire.com/fastly/4da86d8570cf33c05948417ea846a315cf3f52d87a287ba1258a6e0c907b2822.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/8f0b014bb3dcb856e85a9895c566cab86cfe4d455638974fde53abc06a3b27d8.jpeg",
    "https://cdn.faire.com/fastly/66a1cd1bc180662bd95c9dd32a6cd9483b825993cb7780a1546dea9ad8275211.jpeg",
    "https://cdn.faire.com/fastly/985f83652569dc2649d111deace191c4d3df0b74adb6792a692535876c8d4ab8.jpeg",
    "https://cdn.faire.com/fastly/84ac3ea3b2f244cf2d9effd081f35e24592cc8a2446547362a00cc63123306a6.jpeg",
    "https://cdn.faire.com/fastly/1c2d1cb8e3ee0cf92cc6fb80a74101145b68064deb8bf5bcc565a98126b0f20b.jpeg"
  ],
  priceDollars: 6.75,
  description: "Mom said not to pick favorites... These socks are here because you did anyway.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:13.711Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
